import { CityBuilder } from "./city.builder";
import { DocumentReference } from "@angular/fire/firestore";
import { VenueFactory } from "../venue/venue.factory";

export class City {
  public readonly reference: DocumentReference;
  public readonly name: string;
  public readonly coordinates: firebase.firestore.GeoPoint;
  public readonly image: string;
  public readonly isActive: boolean;
  public readonly state: string;
  public readonly timezone: string;
  public readonly totalActiveVenues: number;
  public readonly totalVenues: number;
  public readonly isBannerActive: boolean;
  public readonly bannerImage: string;
  public readonly bannerText: string;
  public readonly isBannerRedirectActive: boolean;
  public readonly bannerRedirectUrl: string;

  public readonly redirect: boolean;
  public readonly redirectUrl: string;
  public readonly addUserId: boolean;

  public venueFactory: VenueFactory;

  constructor(builder: CityBuilder) {
    this.reference = builder.reference;
    this.name = builder.name;
    this.coordinates = builder.coordinates;
    this.image = builder.image;
    this.isActive = builder.isActive;
    this.state = builder.state;
    this.bannerRedirectUrl = builder.bannerRedirectUrl;
    this.isBannerRedirectActive = builder.isBannerRedirectActive;
    this.timezone = builder.timezone;
    this.bannerImage = builder.bannerImage;
    this.bannerText = builder.bannerText;
    this.isBannerActive = builder.isBannerActive;
    this.totalActiveVenues = builder.totalActiveVenues ?? 0;
    this.totalVenues = builder.totalVenues ?? 0;
    this.redirect = builder.redirect;
    this.addUserId = builder.addUserId;
    this.redirectUrl = builder.redirectUrl;
  }

  get id(): string {
    return this.reference.id;
  }
}

export const toAPIRequest = (city: City): any => {
  const cityAPIObject = {
    ...city,
  };
  delete cityAPIObject.reference;

  return cityAPIObject;
}
